var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row bg-title"},[_c('h3',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"mt-10"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }